(function ($) {
    $(function () {
        // =========================================
        // sticky nav (commented out since it's not in use)
        // =========================================
        // $('#main-header').stick_in_parent();

        // =========================================
        // Detect for OLD Android device is < 4.4
        // so offcanvas nav can be handled properly
        // =========================================
        var md = new MobileDetect(window.navigator.userAgent);
        var device = md.os();
        var osVersion = md.version('Android');

        if (device === 'AndroidOS' && osVersion < 4.4) {
            $('body').addClass('old-android');
        }

        // =========================================
        // Prevent default on hamburger
        // =========================================
        $('#small-screen-menu-button a').click(function (e) {
            e.preventDefault();
        });

        // =========================================
        // Execute on initial load
        // =========================================
        //console.log('Script initialized successfully.');
    });
})(jQuery);